import axios from '@/apis/axios';

class ShareCertificate 
{
    static async all()
    {
        const response = await axios.get('/api/company/share-certificates');
         
        return response.data;
    }

    static async getCertificatesWithFilter(query)
    {        
        const response = await axios.get(`/api/company/share-certificates/q?${query}`);
         
        return response.data.data;
    }

    static async getNatureOptions()
    {
        const response = await axios.get('/api/company/share-certificates/nature-options');
        return response.data.data;
    }

    static async getStatusOptions()
    {
        const response = await axios.get('/api/company/share-certificates/status-options');
        return response.data.data;
    }

    static async create(data)
    {
        const response = await axios.post('/api/admin/company/share-certificate', data);

        return response.data.data;
    }

    static async update(id, data)
    {
        const response = await axios.put(`/api/admin/company/share-certificate/${id}`, data);

        return response;
    }

    static async split(id, data)
    {
        const response = await axios.put(`/api/admin/company/split-share-certificate/${id}`, data);

        return response;
    }

    static async delete(id, data)
    {
        const response = await axios.delete(`/api/admin/company/share-certificate/${id}`, data);
        return response;
    }
}
export default ShareCertificate;